import { render, staticRenderFns } from "./RolesForm.vue?vue&type=template&id=2ab7fad1&scoped=true"
import script from "./RolesForm.vue?vue&type=script&lang=js"
export * from "./RolesForm.vue?vue&type=script&lang=js"
import style0 from "./RolesForm.vue?vue&type=style&index=0&id=2ab7fad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab7fad1",
  null
  
)

export default component.exports